import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";
import { useParams, NavLink, useHistory } from "react-router-dom";
// Material UI Component
import {
  FormGroup,
  FormLabel,
  FormControl,
  // ListItemText,
  TextField,
  // Checkbox,
  // FormControlLabel,
  Grid,
  Select,
  InputLabel,
  Input,
  // MenuItem,
  Modal,
  Backdrop,
  Fade,
  FormHelperText,
  NativeSelect,
  Button,
  Typography,
} from "@material-ui/core";
import {
  makeStyles,
  createMuiTheme,
  MuiThemeProvider,
  withStyles,
} from "@material-ui/core/styles";
// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";

import numeral from "numeral";
import MessageBox from "../../../components/MessageBox/MessageBox";
import LoadingModal from "../../../components/Modal/LoadingModal";
import { get_cookies, isLoggedIn } from "../../../components/Cookies/Cookies";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  root: {
    "&$disabled": {
      color: "#f2f2f2",
    },
  },
  disabled: {},
  // paper: {
  // 	backgroundColor: theme.palette.background.paper,
  // 	border: "2px solid #000",
  // 	boxShadow: theme.shadows[5],
  // 	padding: theme.spacing(2, 4, 3),
  // },
}));

const getMuiTheme = () =>
  createMuiTheme({
    overrides: {
      MUIDataTableHeadCell: {
        root: {
          "&:nth-child(1)": {
            width: 120,
          },
          "&:nth-child(2)": {
            width: 120,
          },
          "&:nth-child(3)": {
            width: 160,
          },
          "&:nth-child(4)": {
            width: 160,
          },
        },
      },
    },
  });

const CollectionAllocate = () => {
  const { drpayno, useridNo } = useParams();
  const [unpaidPo, setUnpaidPo] = useState([]);
  const [allocatePO, setAllocatePO] = useState([]);

  //disable/enable allocate button
  const [btnDisabled, setBtnDisabled] = useState(true);

  const [dataLoaded, setDataLoaded] = useState(false);
  const [open, setOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [dateRange, setDateRange] = useState({
    startDate: new Date(),
    endDate: addDays(new Date(), 7),
  });

  //allocate po data
  const [allocateArray, setAllocateArray] = useState([]);
  //eof allocate po data

  //Message Box
  const [showMsgBox, setShowMsgBox] = useState(false);
  const [msgBoxContent, setMsg] = useState("Empty");
  const [msgType, setMsgType] = useState("success");
  const [showModal, setShowModal] = useState(false);
  //Message Box EOF
  const classes = useStyles();

  let history = useHistory();

  // Data Fetching
  useEffect(() => {
    setDataLoaded(true);
    data();
  }, []);

  const x = 0;
  useEffect(() => {
    //
    isLoggedIn();
  }, [x]);

  useEffect(() => {
    if (allocateArray.length > 0) {
      setBtnDisabled(false); // re-enable
    } else {
      setBtnDisabled(true); // re-enable
    }
  }, [allocateArray]);

  const data = async () => {
    await axios
      .get(process.env.REACT_APP_API_URL + "collection_view_allocate", {
        params: {
          drpayno: drpayno,
          jc_user_id_no: useridNo,
        },
      })
      .then((res) => {
        setAllocatePO(res.data.data.general_info);
        setUnpaidPo(res.data.data.allocations);
      })
      .catch((error) => {
        console.log(error.message);
      });

    // const result = await axios.get(
    // 	process.env.REACT_APP_API_URL+'get_po_return_allocate', {
    //     params:{
    // 		poretno: poretno,
    //         jc_u_idno: branchidno,
    //     }
    // })
    // setAllocatePO(res.data.data.general_info);
    // setUnpaidPo(res.data.data.allocations);
  };

  const toggle = () => setOpen(!open);

  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const dateRangeHandler = (range) => {
    setDateRange(range);
    setOpen(false);
  };

  const updateAllocateArray = (recAmount, drno, unpaidamount) => {
    let found = allocateArray.some((x) => x.dr_no === drno);
    if (found) {
      //if item is existing in itemArray, add the qty instead
      let newItems = allocateArray.map((it) => {
        if (it.dr_no === drno) {
          //add
          it.allocated_amt = parseFloat(recAmount);
          //update the allocated amount if it is existing in the state array
        }
        return it;
      });
      setAllocateArray(newItems);
    } else {
      setAllocateArray([
        ...allocateArray,
        //add the new object in the array (for PO allocation)
        {
          dr_no: drno,
          balance: unpaidamount,
          allocated_amt: parseFloat(recAmount),
          // [
          // 	{
          // 		"dr_no": "18971",
          // 		"balance": 6690,
          // 		"allocated_amt" : 6690
          // 	}
          // ]
        },
      ]);
    }
  };

  const removeItem = (dr_no) => {
    let newItems = allocateArray.filter((it) => {
      return it.dr_no !== dr_no;
    });
    setAllocateArray(newItems);
  };

  const ColorButton = withStyles(() => ({
    root: {
      color: "#fff",
      backgroundColor: "#4caf50",
      "&:hover": {
        backgroundColor: "#fff",
        color: "#4caf50",
      },
    },
  }))(Button);

  const columns = [
    {
      name: "date",
      label: "Date",
      options: {
        //filter: false,
        // display: "excluded",
      },
    },
    {
      name: "dr_no",
      label: "DR No.",
    },
    {
      name: "balance",
      label: "balance",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ textAlign: "right" }}>
              {numeral(value).format("0,0.00")}
            </div>
          );
        },
      },
    },
    {
      name: "amount",
      label: "Amount",
      options: {
        customBodyRenderLite: (dataIndex) => {
          let count = unpaidPo[dataIndex].count;
          let balance = unpaidPo[dataIndex].balance;
          let dr_no = unpaidPo[dataIndex].dr_no;
          // $echo.='<input value="0" onchange="amountAllocatePORet('.$count.','.$unpaidamount.');" type="text" id="poret'.$count.'" name="poret'.$count.'" >';
          // let allocateall =  unpaidPo[dataIndex].allocateall;
          return (
            // <Grid container spacing={0} style={{justifyContent: "flex-end"}}>
            <TextField
              classes={classes.rightTxt}
              placeholder="Enter amount to allocate"
              // inputProps={{ 'aria-label': 'Amount' }}
              inputProps={{
                style: { textAlign: "right" },
                "aria-label": "Amount",
              }}
              defaultValue="0"
              type="number"
              id={"dr" + count}
              fullWidth
              onBlur={(e) => amountAllocate(count, balance, e, dr_no)}
              // onChange={e => setuseridNo(e.target.value)}
            />
          );
        },
      },
    },
  ];

  const options = {
    //hide toolbar functions
    toolbar: false,
    filter: false,
    viewColumns: false,
    search: false,
    download: false,
    print: false,
    csv: false,
    // filterType: "dropdown",
    selectableRows: "none",
    responsive: "standard",
    setFilterChipProps: (colIndex, colName, data) => {
      return {
        color: "primary",
        variant: "outlined",
        className: "testClass123",
      };
    },
    // tableBodyHeight,
  };

  const style = {
    marginBottom: "1rem",
    marginTop: "2.5em",
  };
  // item_array:
  // jc_u_idno:DAVAOHQ
  // drpayno:62984
  // drpaybalance:6690

  const allocate_po = async () => {
    setShowModal(true); //show loading/please wait modal
    setBtnDisabled(true); // disable button to avoid multiple saves
    const formData = new FormData();
    formData.append("item_array", JSON.stringify(allocateArray));
    formData.append("jc_u_idno", useridNo);
    formData.append("drpayno", drpayno);
    formData.append("drpaybalance", allocatePO.balance);

    await axios
      .post(process.env.REACT_APP_API_URL + "collection_allocate", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(function (res) {
        setShowModal(false); //hide loading/please wait modal
        setShowMsgBox(true);
        setMsg("Collection Allocation Success");
        setMsgType("success");
        setTimeout(() => {
          setShowMsgBox(false);
          setBtnDisabled(false); // re-enable
          history.push("/sales/collection-history");
        }, 2000);
      })
      .catch(function (error) {
        setShowModal(false); //hide loading/please wait modal
        setShowMsgBox(true);
        setMsg("Something went wrong: " + error);
        setMsgType("warning");
        setTimeout(() => {
          setShowMsgBox(false);
          setBtnDisabled(false); // re-enable
        }, 2500);
      });
  };

  const amountAllocate = (count, unpaidamount, e, drno) => {
    var checker = 1;
    var fieldID = "dr" + count;
    var fieldrun = "dr";
    // var retbalance = document.getElementById("retbalance").value; retbalance=retbalance.replace(/#/ig,"").replace(/&/ig,"").replace(/'"/ig,"");
    let retbalance = allocatePO.balance;
    let grandtotal = allocatePO.grandtotal;
    let recAmount = e.target.value;
    var diff = 0;

    //checker=1;
    if (recAmount == "") {
      document.getElementById(fieldID).value = 0;
    } else {
      if (parseFloat(recAmount) || recAmount == 0) {
        if (recAmount > unpaidamount) {
          checker = 3;
        }
        updateAllocateArray(recAmount, drno, unpaidamount);
      } else {
        document.getElementById(fieldID).value = 0;
      }
    }

    if (checker === 1) {
      var totalamt = 0;
      for (var a = 1; a <= grandtotal; a++) {
        fieldrun = "dr" + a;
        var val = document.getElementById(fieldrun).value;
        totalamt = totalamt * 1 + val * 1;
      }
      diff = retbalance * 1 - totalamt * 1;
      if (diff >= 0) {
        if (totalamt === 0) {
          document.getElementById("allocateBtn").disabled = true;
          setBtnDisabled(true);
        } else {
          setBtnDisabled(false);
          //document.getElementById("allocateBtn").disabled = false;
        }

        // totalamt = number_format(totalamt, 2, '.', ',');
        // setText('allocLabel',totalamt);
      } else {
        // alert("ERROR: You have insufficient balance for allocation.");
        // document.getElementById(fieldID).value=0;
        setShowMsgBox(true);
        setMsg("ERROR: You have insufficient balance for allocation.");
        setMsgType("warning");
        setTimeout(() => {
          setShowMsgBox(false);
        }, 2500);
        e.target.value = 0; //set the input field to 0
        removeItem(drno); //remove the item
      }
    } else if (checker == 3) {
      setShowMsgBox(true);
      setMsg("ERROR: allocated amount exceeds the unpaid amount.");
      setMsgType("warning");
      setTimeout(() => {
        setShowMsgBox(false);
        setBtnDisabled(false); // re-enable
      }, 2500);
      e.target.value = 0; //set the input field to 0
      removeItem(drno); //remove the item
    } else {
      setShowMsgBox(true);
      setMsg("ERROR: Please make sure all values entered are correct.");
      setMsgType("warning");
      setTimeout(() => {
        setShowMsgBox(false);
      }, 2500);
      e.target.value = 0; //set the input field to 0
      removeItem(drno); //remove the item
    }
  };

  return (
    <div className="page">
      <div className="page-header">
        <div className="page-icon">
          <ShoppingCartIcon />
        </div>
        <NavLink to={"/sales"}>
          <h2 style={{ color: "black" }}>Sales</h2>
        </NavLink>
        <ArrowForwardIosIcon
          style={{ paddingLeft: "10px", paddingRight: "10px" }}
        />
        <NavLink to={"/sales/collection-history"}>
          <h2 style={{ color: "black" }}>Collection</h2>
        </NavLink>
        <ArrowForwardIosIcon
          style={{ paddingLeft: "10px", paddingRight: "10px" }}
        />
        <h2>Collection Allocate</h2>
      </div>
      <div className="page-container">
        <LoadingModal showModal={showModal} />
        <MessageBox in={showMsgBox} content={msgBoxContent} type={msgType} />
        <div style={style}>
          <Card>
            <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={7} className={classes.infoContent}>
                  <Typography style={{ fontWeight: "bold", color: "#339933" }}>
                    {allocatePO.name || "Name"}
                  </Typography>
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={4} className={classes.infoTitle}>
                  Balance:
                </Grid>
                <Grid item xs={8} className={classes.infoContent}>
                  {numeral(allocatePO.balance).format("0,0.00") || "0.00"}
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </div>

        {!dataLoaded ? (
          <Preloader />
        ) : (
          <MuiThemeProvider theme={getMuiTheme()}>
            <MUIDataTable
              title={
                <div>
                  <div className="table-subtitle">Table</div>
                  <div className="table-title">Collection Allocate</div>
                </div>
              }
              data={unpaidPo}
              columns={columns}
              options={options}
            />
          </MuiThemeProvider>
          // <div>render table here</div>
        )}
        <Grid container direction="row" justify="flex-end">
          <ColorButton
            disabled={btnDisabled}
            style={{ marginTop: "22px" }}
            id="allocateBtn"
            variant="contained"
            color="primary"
            onClick={() => {
              allocate_po();
            }}
            classes={{
              root: classes.root,
              disabled: classes.disabled,
            }}
          >
            Allocate
          </ColorButton>
        </Grid>
      </div>
    </div>
  );
};

export default CollectionAllocate;
